__turbopack_context__.v({
  "minus-icon": "MinusIcon-module-scss-module__2anPRa__minus-icon",
});
